import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../../utils/baseQuery";
import { components } from "../../types/api";

export type TableView = components["schemas"]["TableViewDto"];
type TableViewsResponse =
  components["schemas"]["ApiResponse_TableViewDto-Array_"];
type TableViewResponse = components["schemas"]["ApiResponse_TableViewDto_"];
export type CreateTableViewRequest =
  components["schemas"]["CreateTableViewBody"];
export type UpdateTableViewRequest =
  components["schemas"]["UpdateTableViewBody"];

/** Vistas guardadas por el usuario para una tabla (p. ej. el WIP). */
export const tableViewsApi = createApi({
  reducerPath: "tableViewsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["TableViews"],
  endpoints: (builder) => ({
    getTableViews: builder.query<TableViewsResponse, string>({
      query: (tableKey) =>
        `/table-views?tableKey=${encodeURIComponent(tableKey)}`,
      providesTags: (_r, _e, tableKey) => [
        { type: "TableViews", id: tableKey },
      ],
    }),
    createTableView: builder.mutation<
      TableViewResponse,
      CreateTableViewRequest
    >({
      query: (body) => ({ url: "/table-views", method: "POST", body }),
      invalidatesTags: (_r, _e, { tableKey }) => [
        { type: "TableViews", id: tableKey },
      ],
    }),
    updateTableView: builder.mutation<
      TableViewResponse,
      { id: string; tableKey: string; body: UpdateTableViewRequest }
    >({
      query: ({ id, body }) => ({
        url: `/table-views/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_r, _e, { tableKey }) => [
        { type: "TableViews", id: tableKey },
      ],
    }),
    deleteTableView: builder.mutation<
      unknown,
      { id: string; tableKey: string }
    >({
      query: ({ id }) => ({ url: `/table-views/${id}`, method: "DELETE" }),
      invalidatesTags: (_r, _e, { tableKey }) => [
        { type: "TableViews", id: tableKey },
      ],
    }),
  }),
});

export const {
  useGetTableViewsQuery,
  useCreateTableViewMutation,
  useUpdateTableViewMutation,
  useDeleteTableViewMutation,
} = tableViewsApi;
